export default __webpack_public_path__ + "static/media/hubs-icon.4a092d73.svg";